import { Alert } from "@deere/ux.uxframe-react";
import { Box, Typography } from "@deere/fuel-react";
import { AGREEMENT_POSITIONS, DISCLAIMER_MSG_CODE } from "../utils/surveyLiterals";

const DisclaimerBox = ({ literals, disclaimerPosition }) => {
  let message = literals.find((item) => item.code === DISCLAIMER_MSG_CODE);
  let showDisclaimer =  disclaimerPosition === AGREEMENT_POSITIONS.SURVEY_SCREEN || disclaimerPosition === AGREEMENT_POSITIONS.BOTH ? true : false;

  if (!message || !showDisclaimer) return null;
  return (
    <Box>
      <Alert accessibilityLabel="warning:" variant="warning">
        <Typography variant="h5" style={{ textAlign: "justify", textAlignLast: "left" }} dangerouslySetInnerHTML={{ __html: message.text }}></Typography>
      </Alert>
    </Box>
  );
};

export default DisclaimerBox;
